import React from "react";

export default function LandForSale() {
  return <div>LandForSale</div>;
}
